<template>
  <div class="confirmation position-relative">
    <div class="text-left form-main">
      <div
        class="mb-2"
        v-for="config in configurationData"
        v-bind:key="config.id"
      >
        <template v-if="config.showInConfirmation">
          <p class="mb-0 font-weight-bolder">{{ config.label }}</p>
          <div v-if="Array.isArray(config.value)">
            <p class="mb-0" v-for="item in config.value" v-bind:key="item">
              {{ item }}
            </p>
          </div>
          <div v-else>
            <p class="mb-0">
              {{ config.value }}
            </p>
          </div>
        </template>
      </div>

      <div v-for="field in personalData" v-bind:key="field.id">
        <template v-if="field.showInConfirmation">
          <p class="mb-0 mr-1 font-weight-bolder d-inline">
            {{ field.label }}:
          </p>
          <template v-if="Array.isArray(field.value)">
            <p
              class="mb-0 d-inline"
              v-for="item in field.value"
              v-bind:key="item"
            >
              {{ item }}
            </p>
          </template>
          <template v-else>
            <p class="mb-0 d-inline">
              {{ field.value }}
            </p>
          </template>
        </template>
      </div>
    </div>
    <div v-if="Object.keys(errors).length" class="w-100 mt-3">
      <div v-for="(v, k) in errors" :key="k">
        <p v-for="error in v" :key="error" class="text-danger lh-1 mb-0">
          <small class="font-weight-bold lh-1" v-html="error"></small>
        </p>
      </div>
    </div>
    <div class="justify-content-between d-flex">
      <div>
        <button
          id="07-anpassen"
          @click="goBack()"
          class="btn btn-outline-primary text-uppercase btn-sm-md-down"
          :disabled="isLoading"
        >
          ANPASSEN
        </button>
      </div>
      <div>
        <button
          id="07-absenden"
          v-on:click="submitForm()"
          class="btn btn-primary text-uppercase btn-sm-md-down"
          :disabled="isLoading"
        >
          ABSENDEN
        </button>
      </div>
    </div>
    <div
      v-if="isLoading"
      class="position-absolute w-100 h-100 d-flex justify-content-center align-items-center"
      style="top: 0; background: rgba(255, 255, 255, 0.9)"
    >
      <div class="spinner-border text-secondary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Confirmation",
  data() {
    return {
      isLoading: false,
      errors: {},
    };
  },
  props: {
    configurationData: Object,
    personalData: Object,
  },
  methods: {
    goBack() {
      this.$emit("goBack");
    },
    async submitForm() {
      let _this = this;
      this.errors = {};

      if (!this.isLoading) {
        this.isLoading = true;

        await this.$recaptchaLoaded();
        const token = await this.$recaptcha("submit");
        const url = "/api/konfigurator-submit";
        const data = {
          configurationData: _this.configurationData,
          personalData: _this.personalData,
          token,
        };
        axios
          .post(url, data)
          .then((response) => {

            _this.isLoading = false;
            if(response.data.success) {
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                configuratorConversion: "1",
                event: "configuratorConversion",
              });
              _this.$emit("formSubmitted");

            } else {
              _this.errors = {'errors':['Versuchen Sie es bitte erneut.']}
            }            
          })
          .catch(function (error) {
            if (error.response.data.errors) {
              _this.errors = error.response.data.errors;
            }
            _this.isLoading = false;
          });
      } else {
        return;
      }
    },
  },
};
</script>